import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAllBannersService } from "network/services/banner.service";

export const fetchAllBanners = createAsyncThunk(
  "banner/all-banners",
  async (_, thunkApi) => {
    try {
      const res = await getAllBannersService();
      // console.error("res", res);
      return res;
    } catch (error) {
      // console.error("resssdd", error);
      return thunkApi.rejectWithValue(error[0]?.description || error.message);
    }
  }
);
